import PreOrder from 'assets/Icons/preOrder';
import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { SortableList } from 'features/settingService/components/SortableList';
import settingApis from 'features/settingService/services/apis';
import { useState } from 'react';
import { getMessageError, IResponseDataBody } from 'services/response';
import shopActions from 'services/shop/actions';
import { IProductCategoryItem } from 'services/shop/types/product';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import toast from 'utils/toast';
type Props = {
  data: IProductCategoryItem[];
};
const ArrangeCategoryModal = ({ data = [] }: Props) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<{ id: string; name: string }[]>([]);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    setItems(data.map((o) => ({ id: o.id, name: o.categoryName })));
    setOpen(true);
  };

  const handlePreOrder = async () => {
    setOpen(false);

    try {
      const res: IResponseDataBody = await settingApis.sortCategories(items.map((o) => o.id));

      if (res?.data?.data) {
        toast.success('Arrange categories successfully');
        dispatch(shopActions.get.productCategories.fetch());
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Arrange categories failed');
    }
  };

  return (
    <>
      <button className='btn-container add-supplier' type='button' onClick={handleOpen}>
        <PreOrder width={60} height={60} />
        Reorder Category
      </button>
      <Modal
        v2
        visible={open}
        onClose={() => setOpen(false)}
        onSubmit={handlePreOrder}
        modalTitle='Reorder Categories'
        noneBodyStyle
        width={700}
      >
        <Container>
          <SortableList
            items={items}
            onChange={setItems}
            renderItem={(item) => (
              <SortableList.Item id={item.id}>
                <CateWrap>
                  <Text variant='H5' color='text_3'>
                    {item.name}
                  </Text>
                </CateWrap>
              </SortableList.Item>
            )}
          />
        </Container>
      </Modal>
    </>
  );
};

export default ArrangeCategoryModal;

const CateWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  .label {
    font-size: 18px;
    font-weight: 600;
  }
`;

const Container = styled.div`
  padding: 16px;
  background-color: #fff;
`;
